import axios from 'axios';

export default {
  /**
   * @async
   * @param {string} url - Supports YouTube, Vimeo, and others (https://noembed.com/)
   * @returns {object} info
   * @returns {string} info.url
   * @returns {string} info.title
   * @returns {string} info.html
   * @returns {string} info.authorName
   * @returns {string} info.providerName
   * @returns {string} info.providerUrl
   * @returns {number} info.width
   * @returns {number} info.height
   * @returns {string} info.thumbnailUrl
   * @returns {number} info.thumbnailWidth
   * @returns {number} info.thumbnailHeight
   * @throws {Error} error
   */
  getInfo(url) {
    // Check if the URL is a Vimeo URL
    const isVimeoUrl = /vimeo\.com/.test(url);

    var options = {
      method: 'GET',
      baseURL: isVimeoUrl ? 'https://vimeo.com' : 'https://noembed.com',
      url: isVimeoUrl ? '/api/oembed.json' : '/embed',
      params: {
        url: url
      }
    };

    return axios.request(options).then(function(response) {
      console.log(response)
      // It appears that this service doesn't escape quotes in their JSON
      // responses, meaning that if the URL has quotes in it, it causes the body
      // parser to fail.
      if (typeof response.data === 'string') {
        throw new Error('Invalid response from oembed service');
      }
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return {
        url:             response.data.url,
        title:           response.data.title,
        html:            response.data.html,
        authorName:      response.data.author_name,
        providerName:    response.data.provider_name,
        providerUrl:     response.data.provider_url,
        width:           response.data.width,
        height:          response.data.height,
        thumbnailUrl:    response.data.thumbnail_url,
        thumbnailWidth:  response.data.thumbnail_width,
        thumbnailHeight: response.data.thumbnail_height,
      };
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/noembed/index.js